const registerComponentModule = (store, moduleFactory) => {
  for (const endpointDependency in moduleFactory.getEndpoints()) {
    if (Object.prototype.hasOwnProperty.call(moduleFactory.getEndpoints(), endpointDependency)) {
      registerEndpointModule(store, moduleFactory.getEndpoints()[endpointDependency]);
    }
  }
};
const registerEndpointModule = (store, moduleFactory) => {
  if (!store.hasModule(moduleFactory.getNameSpace())) {
    store.registerModule(moduleFactory.getNameSpace(), moduleFactory.getModule());
  }
};

export { registerComponentModule, registerEndpointModule };
